let Http = require('./http');

module.exports = {
	mixins: [Http],

	props: {
		defaults: {
			required: true,
			type: Object
		},
		endpoint: {
			required: true,
			type: String
		},
		preferences: {
			type: Object
		}
	},

	data() {
		return {
			userPreferences: this.preferences,
			userPreferencesDefaults: this.defaults,
			userPreferencesSaving: false,
			userPreferencesSaved: false
		}
	},

	created() {
		this.userPreferences = Object.assign({}, this.userPreferencesDefaults, this.userPreferences);
	},

	methods: {
		submitUserPreferences: _.debounce(function() {
			this.userPreferencesSaving = true;
			this.$emit('saving', this.preferences);
			this.sendRequest(this.endpoint, 'post', this.afterSubmitUserPreferences, this.userPreferences);
		}, 500),

		afterSubmitUserPreferences(data, message) {
			this.userPreferencesSaving = false;
			this.userPreferencesSaved = true;
			this.displayMessage(message.content, message.type);
			this.$emit('saved', data, message);
		},

  		userPreferencesAnswerSelected(type, answer) {
  			if(!this.userPreferences[type]) {
  				return false;
  			}

			if(Array.isArray(this.userPreferences[type])) {
  				return (this.userPreferences[type].indexOf(answer) > -1);
  			} else {
  				return (this.userPreferences[type] === answer);
  			}
  		}
	}
}
